export const ageMethod = "age nearest";
export const gateway = "https://canary-greengardens-shopper-api.link.wawanesalife.com";
export const assets = "https://canary-assets.link.wawanesalife.com/brokers/greengardens";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJncmVlbmdhcmRlbnMiLCJuYW1lIjoiZ3JlZW5nYXJkZW5zIiwiaWF0IjoxNzgwNjAxMzU4LCJleHAiOjE5MzgzODkzNTh9.ZhyvEBKCwaovoOB_yq0Quq79NthsIbvTmLKK2awasOc";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"canary-greengardens-shopper.link.wawanesalife.com": {
		a: {
			accessibilityLink: "https://en.wikipedia.org/wiki/Web_Content_Accessibility_Guidelines",
			approve_company: "Link Platform",
			approve_user: "link_greengardens",
			brands: [
				"canary-greengardens-shopper.link.wawanesalife.com",
			],
			broker: "greengardens",
			broker_formatted_name: "Green Gardens Insurance",
			email: "service@greengardens.ca",
			environment: "canary",
			environment_id: "canary",
			ftcLink: "https://www.fsrao.ca/regulation/guidance/fair-treatment-customers-insurance",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"True North Tower": [
					"236 Carlton",
					"Winnipeg",
					"MB",
					"R3C 1P5",
				],
				"River Park branch": [
					"845 Dakota St Unit 30",
					"Winnipeg",
					"MB",
					"R2M 5M3",
				],
				"Jack Blick branch": [
					"1440 Jack Blick Ave",
					"Winnipeg",
					"MB",
					"R3G 0L4",
				],
				"Saskatoon branch": [
					"100-3020 Preston Ave S",
					"Saskatoon",
					"SK",
					"S7T 0V2",
				],
				"Waverley branch": [
					"840 Waverley St",
					"Winnipeg",
					"MB",
					"R3T 5Z7",
				],
			},
			menuPhone: "button",
			phone: "204.555.4321",
			photos: [
				"carousel1.jpg",
				"carousel2.jpg",
				"carousel3.jpg",
				"carousel4.jpg",
				"carousel5.jpg",
				"carousel6.jpg",
				"carousel7.jpg",
				"carousel8.jpg",
				"carousel9.jpg",
				"carousel10.jpg",
				"carousel11.jpg",
			],
			privacyLink: "https://www.priv.gc.ca/en/privacy-topics/privacy-laws-in-canada/the-personal-information-protection-and-electronic-documents-act-pipeda/",
			website: "https://canary-greengardens-shopper.link.wawanesalife.com",
			scope: "greengardens#branding#canary-greengardens-shopper.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "canary-greengardens-shopper.link.wawanesalife.com",
		},
		b: {
			accessibilityLink: "https://en.wikipedia.org/wiki/Web_Content_Accessibility_Guidelines",
			approve_company: "Link Platform",
			approve_user: "link_greengardens",
			brands: [
				"canary-greengardens-shopper.link.wawanesalife.com",
			],
			broker: "greengardens",
			broker_formatted_name: "Green Gardens Insurance",
			email: "service@greengardens.ca",
			environment: "canary",
			environment_id: "canary",
			ftcLink: "https://www.fsrao.ca/regulation/guidance/fair-treatment-customers-insurance",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"True North Tower": [
					"236 Carlton",
					"Winnipeg",
					"MB",
					"R3C 1P5",
				],
				"River Park branch": [
					"845 Dakota St Unit 30",
					"Winnipeg",
					"MB",
					"R2M 5M3",
				],
				"Jack Blick branch": [
					"1440 Jack Blick Ave",
					"Winnipeg",
					"MB",
					"R3G 0L4",
				],
				"Saskatoon branch": [
					"100-3020 Preston Ave S",
					"Saskatoon",
					"SK",
					"S7T 0V2",
				],
				"Waverley branch": [
					"840 Waverley St",
					"Winnipeg",
					"MB",
					"R3T 5Z7",
				],
			},
			menuPhone: "button",
			phone: "204.555.4321",
			photos: [
				"carousel1.jpg",
				"carousel2.jpg",
				"carousel3.jpg",
				"carousel4.jpg",
				"carousel5.jpg",
				"carousel6.jpg",
				"carousel7.jpg",
				"carousel8.jpg",
				"carousel9.jpg",
				"carousel10.jpg",
				"carousel11.jpg",
			],
			privacyLink: "https://www.priv.gc.ca/en/privacy-topics/privacy-laws-in-canada/the-personal-information-protection-and-electronic-documents-act-pipeda/",
			website: "https://canary-greengardens-shopper.link.wawanesalife.com",
			scope: "greengardens#branding#canary-greengardens-shopper.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "canary-greengardens-shopper.link.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 19:29:18 GMT+0000 (Coordinated Universal Time)
